module.exports = __webpack_public_path__ + "static/media/edit-icon.9d4ed43e.svg";